var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.link ? 'a' : 'button',{tag:"component",class:[_vm.$style['button'], _vm.$style[("button--" + _vm.type)]],attrs:{"href":_vm.link,"target":_vm.target}},[_vm._t("default"),_vm._v(" "+_vm._s(_vm.text)+" ")],2)}
var staticRenderFns = []

export { render, staticRenderFns }